module.exports = __webpack_public_path__ + "assets/svg/Icons/32/announcement-red-9379f5.svg";